import React, { useEffect, useState, useRef } from 'react';

/*
  SectionNav — minimal vertical navigation on the right side.
  Uses IntersectionObserver to detect the active section.
  Auto-switches between light/dark theme based on the current section's data-theme attribute.
*/
export default function SectionNav({ items }) {
  const [active, setActive] = useState(items[0]?.id);
  const [theme, setTheme] = useState('light');
  const observersRef = useRef([]);

  useEffect(() => {
    // Set up an IntersectionObserver per section
    const observers = [];
    items.forEach((it) => {
      const el = document.getElementById(it.id);
      if (!el) return;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActive(it.id);
              const t = el.getAttribute('data-theme') || 'light';
              setTheme(t);
            }
          });
        },
        {
          // consider section active when its middle crosses the viewport middle
          rootMargin: '-40% 0px -50% 0px',
          threshold: 0,
        }
      );
      io.observe(el);
      observers.push(io);
    });
    observersRef.current = observers;
    return () => observers.forEach((o) => o.disconnect());
  }, [items]);

  const handleClick = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav className={`section-nav ${theme === 'dark' ? 'on-dark' : ''}`} aria-label="Sezioni del sito">
      {items.map((it, idx) => (
        <button
          key={it.id}
          onClick={() => handleClick(it.id)}
          className={`section-nav-item ${active === it.id ? 'active' : ''}`}
          aria-label={it.label}
          aria-current={active === it.id ? 'location' : undefined}
        >
          <span className="track" aria-hidden="true" />
          <span className="label">
            <span className="num" aria-hidden="true">{String(idx + 1).padStart(2, '0')}</span>
            <span className="txt">{it.label}</span>
          </span>
        </button>
      ))}
    </nav>
  );
}
